<template>
	<Service class="patrash">
		<h2>Service</h2>

		<p class="year">2016</p>

		<h3>PaTrash（パトラッシュ）</h3>

		<p class="event">MashupAwards2016 福井ハッカソン 最優秀賞</p>
		<p class="role">idea / logo / UI Design / coding</p>

		<section class="logo content-box">
			<h4>Logo</h4>
			<img src="images/service/patrash/logo.png" />
			<p>当初はBOCCOを使った作品だったため、BOCCOのイメージ。</p>
		</section>

		<section class="target content-box">
			<h4>Target</h4>
			<p>自分。朝、雨が降るとゴミ捨ての面倒な主婦。ワーキングママ。単身赴任のお父さん。</p>
		</section>

		<section class="problem content-box">
			<h4>Problem</h4>
			<p>
				雨がふると、ゴミ捨てに行くのが億劫になる。各部屋のゴミの量が把握できない。
				今日は何のゴミの日なのかを、忘れてしまう。
			</p>
		</section>

		<section class="solution content-box">
			<h4>Solution</h4>

			<p>
				次の日の朝のゴミ捨ての天気・何を捨てる日なのかがわかって雨の中ゴミ捨てに行かなくてすむ。
				お気に入り商品など、カメラで何を捨てたのか判断し家の在庫切れを防ぎます。
				アプリで、部屋のゴミ箱の設定をして、ゴミ出しの日やゴミ箱がいっぱいかを通知します。
			</p>
		</section>

		<section class="blog content-box">
			<h4>Blog</h4>

			<p>
				少しのチャレンジと、いつもの狂気と。#MA_2016
				<br />
				<a
					href="http://kotobuking.net/kotoblog/2016/10/ma2016_fukuihack/"
					target="_blank"
					class="url"
				>http://kotobuking.net/kotoblog/2016/10/ma2016_fukuihack/</a>
			</p>
		</section>

		<section class="design">
			<h4>Design</h4>
			<p>キャラクター化したPaTrashが、まるでペットのように話しかけるイメージ。</p>
			<p>
				PaTrash アプリ
				<br />
				<iframe
					class="youtube"
					width="560"
					height="315"
					src="https://www.youtube.com/embed/PqVpN_A2Beg"
					frameborder="0"
					allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
					allowfullscreen
				></iframe>
			</p>
			<img src="images/service/patrash/screens.png" />
			<img src="images/service/patrash/illust.png" />
			<img src="images/service/patrash/cover.png" />
		</section>
	</Service>
</template>

<style lang="scss" scoped>
.patrash {
	.logo {
		> img {
			width: 275px;
			margin-bottom: 30px;
		}

		p {
			width: 320px;
			margin: 0 auto;
		}
	}

	.blog {
		> p {
			text-align: center;
		}
	}

	.design {
		p {
			text-align: center;
			margin-bottom: 20px;
		}

		img {
			width: 600px;
			margin: 0 auto 24px;
		}
	}
		@media screen and (max-width: 480px) { 

.logo {
		> img {
			width: 275px;
			margin-bottom: 30px;
		}

		p {
			width: 90%;
			margin: 0 auto;
		}
	}

	.blog {
		> p {
			text-align: center;
		}
	}

	.design {
		p {
			text-align: center;
			margin-bottom: 20px;
		}

		img {
			width: 100%;
			margin: 0 auto 24px;
		}
	}
	iframe{
		width: 100%;
	}

		}
}
</style>

<script>
import Service from "@/components/Service.vue";

export default {
	components: {
		Service
	}
};
</script>
